import Networker from './networker';
import URLs from '../constants/urls';

export default class ProductService {
    static getProduct(id) {
        return Networker.get(URLs.products.get+id);
    }
}